import React from 'react';
import PropTypes from 'prop-types';
import { Container, Button, Image } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import styles from './../style/DeliverySection.module.scss';

class DeliverySection extends React.Component {
  constructor(props) {
    super(props);
    this.swiperRef = React.createRef();
    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext();
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev();
    }
  }

  renderPodmena1(podmena) {
    return (
      <div className="d-md-none" style={{ width: '100%', maxWidth: '516px', aspectRatio: '355 / 438', position: 'relative' }}>
        {podmena?.wlogo && (
          <img
            src={podmena.wlogo}
            alt="StomaHelp"
            fetchpriority="high"
            style={{
              position: 'absolute',
              width: '83px',
              height: 'auto',
              top: '22px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 10
            }}
          />
        )}
        <div style={{ width: '100%', height: '100%', left: 0, top: 0, position: 'absolute', overflow: 'hidden' }}>
          <div style={{ width: '100%', height: '100%', left: 0, top: 0, position: 'absolute', background: 'linear-gradient(174deg, #556BFF 0%, #556BFF 100%)' }}></div>
          <div style={{ width: '100%', height: '100%', left: 0, top: 0, position: 'absolute' }}>
            <svg width="100%" height="100%" viewBox="0 0 355 438" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="waveGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#4B72F5"/>
                  <stop offset="100%" stopColor="#577CFD"/>
                </linearGradient>
              </defs>
              <rect width="355" height="438" fill="url(#waveGrad1)"/>
              <path d="M0 200 Q 88.75 280, 177.5 220 T 355 200 L 355 438 L 0 438 Z" fill="url(#waveGrad1)" opacity="0.6"/>
              <path d="M0 240 Q 88.75 300, 177.5 260 T 355 240 L 355 438 L 0 438 Z" fill="url(#waveGrad1)" opacity="0.4"/>
            </svg>
          </div>
          <div data-model="iPhone 14 15 Pro" data-style="fill" style={{ width: '58.99%', height: '59.13%', left: '20.28%', top: '40.87%', position: 'absolute', overflow: 'hidden' }}>
            <img fetchpriority="high" style={{ width: '100%', height: '100%', left: 0, top: 0, position: 'absolute' }} src={podmena?.phone} alt="" />
          </div>
          <div style={{ width: '42.60%', left: '28.74%', top: '58.41%', position: 'absolute', textAlign: 'center', color: 'rgba(0, 0, 0, 0.60)', fontSize: '6.77px', fontFamily: 'Inter', fontWeight: 400, lineHeight: '6.20px', wordWrap: 'break-word' }}>Заполните поля, чтобы найти сертификат ТСР и оплатить заказ</div>
          <img fetchpriority="high" style={{ width: '15.28%', height: '3.16%', left: '49.87%', top: '63.15%', position: 'absolute' }} src={podmena?.sert} alt="" />
          <img fetchpriority="high" style={{ width: '12.36%', height: '10.02%', left: '35.57%', top: '59.84%', position: 'absolute' }} src={podmena?.mir} alt="" />
          <div style={{ width: '49.43%', left: '25.16%', top: '49.97%', position: 'absolute', textAlign: 'center', color: 'black', fontSize: '14.44px', fontFamily: 'Inter', fontWeight: 600, lineHeight: '14.44px', wordWrap: 'break-word' }}>Оплата электронным сертификатом</div>
          <div style={{ width: '49.43%', height: '5%', left: '25.16%', top: '68.14%', position: 'absolute', background: '#F6F9FA', borderRadius: '173.17px' }}></div>
          <div style={{ width: '49.43%', height: '5%', left: '25.16%', top: '73.96%', position: 'absolute', background: '#F6F9FA', borderRadius: '173.17px' }}></div>
          <div style={{ width: '49.43%', height: '5%', left: '25.16%', top: '79.76%', position: 'absolute', background: '#F6F9FA', borderRadius: '173.17px' }}></div>
        </div>
        <div style={{ width: '91.27%', left: '4.23%', top: '13.47%', position: 'absolute', textAlign: 'center', color: 'white', fontSize: '22px', fontFamily: 'Inter', fontWeight: 600, lineHeight: '22px', wordWrap: 'break-word' }}>
          Оформите электронный сертификат для покупки средств реабилитации
        </div>
        <div style={{ width: '60.85%', left: '19.44%', top: '31.05%', position: 'absolute', textAlign: 'center', color: 'rgba(255, 255, 255, 0.60)', fontSize: '12px', fontFamily: 'Inter', fontWeight: 400, wordWrap: 'break-word' }}>Сделайте шаг к улучшению качества жизни уже сегодня!</div>
        <div style={{ width: '40.28%', height: '25.11%', left: '4.23%', top: '74.89%', position: 'absolute', background: 'rgba(0, 19.67, 152.02, 0.47)', borderTopLeftRadius: '15px', borderTopRightRadius: '15px', backdropFilter: 'blur(16.15px)' }}></div>
        <div style={{ width: '8.45%', aspectRatio: '1', left: '8.45%', top: '78.31%', position: 'absolute', background: 'rgba(126.27, 142.93, 255, 0.40)', borderRadius: '50px' }}></div>
        <img fetchpriority="high" style={{ width: '4.51%', aspectRatio: '1', left: '10.42%', top: '79.91%', position: 'absolute' }} src={podmena?.lovely} alt="" />
        <div style={{ width: '49.30%', height: '25.11%', left: '46.20%', top: '74.89%', position: 'absolute', background: 'rgba(0, 19.67, 152.02, 0.47)', borderTopLeftRadius: '15px', borderTopRightRadius: '15px', backdropFilter: 'blur(16.15px)' }}></div>
        <div style={{ width: '8.45%', aspectRatio: '1', left: '50.42%', top: '78.31%', position: 'absolute', background: 'rgba(126.27, 142.93, 255, 0.40)', borderRadius: '50px' }}></div>
        <img fetchpriority="high" style={{ width: '4.51%', aspectRatio: '1', left: '52.39%', top: '79.91%', position: 'absolute' }} src={podmena?.clock} alt="" />
        <div style={{ width: '34.37%', left: '8.45%', top: '86.99%', position: 'absolute', color: 'rgba(255, 255, 255, 0.70)', fontSize: '12px', fontFamily: 'Inter', fontWeight: 400, lineHeight: '15px', wordWrap: 'break-word' }}>Выбираете средства, которые подходят именно вам</div>
        <div style={{ width: '40.85%', left: '50.42%', top: '86.99%', position: 'absolute', color: 'rgba(255, 255, 255, 0.70)', fontSize: '12px', fontFamily: 'Inter', fontWeight: 400, lineHeight: '15px', wordWrap: 'break-word' }}>Не тратьте ваше время на ожидание от Социального фонда России</div>
      </div>
    );
  }

  renderPodmena2(podmena) {
    return (
      <div className="d-md-none" style={{ width: '100%', maxWidth: '516px', aspectRatio: '355 / 438', position: 'relative' }}>
        {podmena?.wlogo && (
          <img
            src={podmena.wlogo}
            alt="StomaHelp"
            style={{
              position: 'absolute',
              width: '83px',
              height: 'auto',
              top: '22px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 10
            }}
          />
        )}
        <div style={{ width: '100%', height: '100%', left: 0, top: 0, position: 'absolute', overflow: 'hidden' }}>
          <div style={{ width: '100%', height: '100%', left: 0, top: 0, position: 'absolute', background: 'linear-gradient(174deg, #E30613 0%, #E30613 100%)' }}></div>
          <img fetchpriority="high" style={{ width: '100%', height: '100%', left: 0, top: 0, position: 'absolute' }} src={podmena?.slydebg2} alt="" />
          <div style={{ width: '64.23%', height: '78.31%', left: '4.51%', top: '43.38%', position: 'absolute', background: 'rgba(0, 0, 0, 0.20)', borderRadius: '15px', backdropFilter: 'blur(3.10px)' }}></div>
          <div style={{ width: '59.15%', left: '8.73%', top: '57.08%', position: 'absolute', color: 'rgba(255, 255, 255, 0.70)', fontSize: '12px', fontFamily: 'Inter', fontWeight: 400, lineHeight: '15px', wordWrap: 'break-word' }}>производится из современного импортного сырья с применением новейших технологий.</div>
          <div style={{ width: '43.38%', left: '21.41%', top: '49.09%', position: 'absolute', color: 'white', fontSize: '14px', fontFamily: 'Inter', fontWeight: 500, lineHeight: '16px', wordWrap: 'break-word' }}>Продукция StomaHelp</div>
          <div style={{ width: '10.70%', aspectRatio: '1', left: '8.73%', top: '46.80%', position: 'absolute', background: 'rgba(255, 78.46, 88.85, 0.40)', borderRadius: '50px' }}></div>
          <img style={{ width: '5.63%', aspectRatio: '1', left: '11.27%', top: '48.86%', position: 'absolute' }} src={podmena?.like} alt="" />
          <div style={{ width: '1.68%', height: '24.82%', left: '67.03%', top: '70.40%', position: 'absolute', transform: 'rotate(6deg)', transformOrigin: 'top left', boxShadow: '53.80px 53.80px 53.80px', outline: '22px black solid', outlineOffset: '-11px', filter: 'blur(26.90px)' }}></div>
        </div>
        <div style={{ width: '91.27%', left: '4.23%', top: '18.72%', position: 'absolute', textAlign: 'center', color: 'white', fontSize: '22px', fontFamily: 'Inter', fontWeight: 600, lineHeight: '25px', wordWrap: 'break-word' }}>
          Высокое качество продукции и эффективность уходовых средств за стомой
        </div>
      </div>
    );
  }

  render() {
    const { page_data, resource, user_profile_type } = this.props;
    const podmena = resource?.podmena || {};

    return (
      <section>
        <h2 className="visually-hidden">Доставка</h2>
        <Container className={styles.container}>
          <div className={styles.container_block}>
            {/* Слайдер с доставкой */}
            <div className={styles.deliverySlider}>
              <Swiper
                ref={this.swiperRef}
                modules={[Navigation, Autoplay]}
                spaceBetween={20}
                slidesPerView={1}
                loop={true}
                className={styles.swiper}
                autoplay={{
                  delay: 12000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                  stopOnLastSlide: false,
                }}
                observer={false}
                resizeObserver={false}
              >
                {resource.slydes.map((item, index) => (
                  <SwiperSlide key={index} className={styles.slide}>
                    {/* Десктоп: всегда обычное изображение */}
                    <Image style={{ imageRendering: `pixelated` }} fetchpriority='high' className='d-none d-md-block' src={item.image} alt={item.name} title={item.name} width="917" height="325" />
                    {/* Мобильные: если podmena == 1 или 2 — показываем подменный слайд, иначе обычное моб. изображение */}
                    {item?.podmena == 1 ? (
                      this.renderPodmena1(podmena)
                    ) : item?.podmena == 2 ? (
                      this.renderPodmena2(podmena)
                    ) : (
                      <Image style={{ imageRendering: `pixelated` }} fetchpriority='high' className='d-block d-md-none' src={item.image_mob} alt={item.name} title={item.name} width="355" height="325" />
                    )}
                  </SwiperSlide>
                ))}
              </Swiper>

              {/* Кастомные кнопки навигации */}
              <div className={`${styles.navButtonPrev}`} onClick={this.prevSlide}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" rx="12" fill="white"/>
                  <path d="M14 6L8 12L14 18" stroke="#B3B3B3" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
              <div className={`${styles.navButtonNext}`} onClick={this.nextSlide}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" rx="12" fill="white"/>
                  <path d="M10 6L16 12L10 18" stroke="#B3B3B3" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
            </div>

            {user_profile_type == `legal` ?
              <div className={styles.solutionBlock}>
                <div className={styles.solutionTitle + ` d-none d-md-block`}>
                  С заботой<br />
                  для каждого
                </div>
                <h2 className={styles.solutionTitle + ` d-md-none`}>
                  С заботой для каждого
                </h2>
                <p className={styles.solutionText}>
                  Товары для реабилитации после операций, травм и заболеваний
                </p>

                <div className={styles.statItems}>
                  <div className={styles.statItem}>
                    <div className={styles.recommend}>
                      <Image alt="рекомендуют" src="/images/recommend.png" width="85" height="35" />
                      <div className={styles.recommendText}>
                        Более 2000 рекомендуют
                      </div>
                    </div>
                    <div className={styles.divider}></div>
                  </div>

                  <div className={styles.statItemSMob}>
                    <div className={styles.statItem}>
                      <div className={styles.rating}>
                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.52447 0.463526C7.67415 0.0028708 8.32585 0.00286996 8.47553 0.463525L9.90837 4.87336C9.97531 5.07937 10.1673 5.21885 10.3839 5.21885H15.0207C15.505 5.21885 15.7064 5.83865 15.3146 6.12336L11.5633 8.84878C11.3881 8.9761 11.3148 9.20179 11.3817 9.4078L12.8145 13.8176C12.9642 14.2783 12.437 14.6613 12.0451 14.3766L8.29389 11.6512C8.11865 11.5239 7.88135 11.5239 7.70611 11.6512L3.95488 14.3766C3.56303 14.6613 3.03578 14.2783 3.18546 13.8176L4.6183 9.4078C4.68524 9.20179 4.61191 8.9761 4.43667 8.84878L0.685441 6.12336C0.293584 5.83866 0.494972 5.21885 0.979333 5.21885H5.6161C5.83272 5.21885 6.02469 5.07937 6.09163 4.87336L7.52447 0.463526Z" fill="#FFD900"/>
                        </svg>
                        <span className={styles.ratingValue}>4.9 из 5</span>
                      </div>
                      <div className={styles.ratingLabel}>Рейтинг нашего магазина</div>
                    </div>
                    
                    <Button as="a" href={page_data?.link_catalog} variant="primary" className={styles.catalogButton}>Перейти в каталог</Button>
                  </div>
                </div>
              </div>
            :
              <div className={styles.solutionBlock}>
                <Image className={styles.solutionBlockSertImg} src={resource?.sertfon} width={182} height={162} alt={`Cертификат`} />
                <div className={styles.solutionTitle}>
                  Оплачивайте<br />{` `}
                  электронным<br />{` `}
                  сертификатом
                </div>
                <p className={styles.solutionText}>
                  Оплачивайте товары при
                  помощи сертификата, выданного
                  Социальным фондом России
                </p>
                <Button as="a" href={resource?.link_sert} variant="primary" className={styles.catalogButton}>О сертификате</Button>
              </div>
            }
          </div>
        </Container>
      </section>
    );
  }
}

DeliverySection.propTypes = {
  page_data: PropTypes.object,
  resource: PropTypes.object,
  user_profile_type: PropTypes.string
};

DeliverySection.defaultProps = {
  page_data: {},
  resource: {
    slydes: [],
    sertfon: '',
    link_sert: '',
    podmena: {}
  },
  user_profile_type: ''
};

export default DeliverySection;